import { Box, IconButton, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { Page } from '../components/custom';
import { ArrowLeftIcon } from '../components/icons';
import ManageBeneficiaries from '../modules/BillPayment/Beneficiaries/ManageBeneficiaries';

export default function BillBeneficiariesPage() {
  const navigate = useNavigate();

  return (
    <Page title="Beneficiaries Page">
      <Box display="flex" alignItems="center" gap={4} mb="2.125rem">
        <IconButton
          onClick={() => navigate('/app/bill-payment')}
          aria-label="Go Back"
          variant="unstyled"
          icon={<ArrowLeftIcon />}
        />
        <Text color="gray.300">Go Back</Text>
      </Box>

      <section>
        <ManageBeneficiaries />
      </section>
    </Page>
  );
}
